/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPushNotificationState
 */
export interface UserPushNotificationState {
    /**
     * 
     * @type {string}
     * @memberof UserPushNotificationState
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserPushNotificationState
     */
    pushNotificationsDenied?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserPushNotificationState
     */
    pushNotificationsDeniedDate?: Date;
}

/**
 * Check if a given object implements the UserPushNotificationState interface.
 */
export function instanceOfUserPushNotificationState(value: object): value is UserPushNotificationState {
    return true;
}

export function UserPushNotificationStateFromJSON(json: any): UserPushNotificationState {
    return UserPushNotificationStateFromJSONTyped(json, false);
}

export function UserPushNotificationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPushNotificationState {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'pushNotificationsDenied': json['pushNotificationsDenied'] == null ? undefined : json['pushNotificationsDenied'],
        'pushNotificationsDeniedDate': json['pushNotificationsDeniedDate'] == null ? undefined : (new Date(json['pushNotificationsDeniedDate'])),
    };
}

export function UserPushNotificationStateToJSON(value?: UserPushNotificationState | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'pushNotificationsDenied': value['pushNotificationsDenied'],
        'pushNotificationsDeniedDate': value['pushNotificationsDeniedDate'] == null ? undefined : ((value['pushNotificationsDeniedDate']).toISOString()),
    };
}

